import { swaDate } from "@swa-ui/date";
import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

let schema;

export const getDateSchema = (lastBookableDate) => {
  if (!schema) {
    schema = yup
      .string()
      .test(
        "LastBookableDate",
        i18n("schema__ERROR_MAX_DATE", lastBookableDate.format("MM/DD/YYYY")),
        (value) => {
          let valid = true;

          if (value) {
            valid = swaDate(value).isBefore(lastBookableDate, "day");
          }

          return valid;
        }
      );
  }

  return schema;
};
